import { i18n, inject, pr, React, RouteComponentProps, ui } from "aaa";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { history } from "stores/RouterStore";
import { MessageScreen } from "../../common/MessageScreen";
import { CardTanSettingsRoutes } from "./CardTanSettingsRoutes";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
}

@inject("externalInterfaceStore")
export class CardTanSettingsLimitSuccess extends React.Component<RouteComponentProps<{}> & IProps> {
    render() {
        return (
            <MessageScreen
                useWebVersion
                variant="success"
                icon={pr.IconMessageOk}
                title={ui.__("sidentitySettings.limit.success.title")}
                messageComponent={<i18n.FormattedHTMLMessage id="sidentitySettings.limit.success.message" />}
                buttonLabelId="common.close"
                onDismiss={() => {
                    if (history.location.pathname.startsWith(CardTanSettingsRoutes.LIMIT)) {
                        pushRoute(CardTanSettingsRoutes.ROOT);
                    } else if (history.location.pathname.startsWith(CardTanSettingsRoutes.ONBOARDING_LIMIT)) {
                        this.props.externalInterfaceStore.raiseExitSuccess();
                    }
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/cardTanSettings/CardTanSettingsLimitSuccess.tsx